import { render, staticRenderFns } from "./CardSubjectInfo.vue?vue&type=template&id=8cb5a38a&scoped=true&"
import script from "./CardSubjectInfo.vue?vue&type=script&lang=js&"
export * from "./CardSubjectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb5a38a",
  null
  
)

export default component.exports